import styled from 'styled-components';

export default styled.div`
  position: absolute;
  max-width: 100%;
  z-index: ${({ visible }) => (visible ? '1' : '0')};
  opacity: ${({ visible }) => (visible ? '1' : '0')};
  transition: opacity 250ms cubic-bezier(0.4, 0, 0.2, 1);
`;
